import { Component, OnInit, ViewChild } from '@angular/core';
import { process, SortDescriptor } from '@progress/kendo-data-query';
import { Router } from '@angular/router';
import { DocumentService } from 'src/app/shared/services/documents/document.service';
import { DisplayNotificationService } from 'src/app/shared/services/common/notification.service';
import { HttpErrorResponse } from '@angular/common/http';
import { DataBindingDirective } from '@progress/kendo-angular-grid';

@Component({
  selector: 'app-member-document-history',
  templateUrl: './member-document-history.component.html',
  styleUrls: ['./member-document-history.component.css']
})
export class MemberDocumentHistoryComponent implements OnInit {
  @ViewChild(DataBindingDirective, { static: true }) dataBinding: DataBindingDirective;
  public gridView: any;
  public sort: SortDescriptor[] = [{
    field: 'created',
    dir: 'desc'
  }];
  public gridHeight = {
    height: 'calc(100vh - 185px)'
  };

  constructor(
    private router: Router,
    private documentService: DocumentService,
    private notificationService: DisplayNotificationService) { }

  ngOnInit() {
    this.notificationService.setUpLoading(true);
    this.loadMemDocHistory();
  }

  loadMemDocHistory() {
    this.documentService.getMemDocHistory().subscribe((data: any) => {
      if (data && data.statusCode === 200 && data.result) {
        data.result.forEach((element) => {
          element.created = new Date(element.created);
        });
        this.gridView = data.result;
      } else if (data && data.statusCode === 204) {
        this.gridView = [];
      } else if (data.statusCode === 403) {
        this.router.navigate(['/forbidden']);
      } else {
        this.notificationService.setErrorNotification();
      }
      this.notificationService.setUpLoading(false);
    }, (error: HttpErrorResponse) => {
      console.log(error);
      this.notificationService.setUpLoading(false);
      this.notificationService.setErrorNotification();
    });
  }

}
